// News Management APIs
/**
 * @function ApiClient#AddNews
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} startDate = ""
 * @param {any} endDate = ""
 * @param {any} newsData
 * @param {any} files
 * @param {any} images
 * @param {any} options = {}
 */
export async function AddNews(cid, startDate = "", endDate = "", newsData, files, images, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(newsData));
  if (files) {
    files.forEach((f) => {
      formData.append("File", f);
    });
  }
  if (images) {
    images.forEach((i) => {
      formData.append("Image", i);
    });
  }

  return await this._post(`/community/${cid}/news?st=${startDate}&et=${endDate}`, formData, options);
}

/**
 * @function ApiClient#UpdateNews
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} startDate = ""
 * @param {any} endDate = ""
 * @param {any} newsData
 * @param {any} files
 * @param {any} images
 * @param {any} options = {}
 */
export async function UpdateNews(cid, startDate = "", endDate = "", newsData, files, images, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(newsData));
  if (files) {
    files.forEach((f) => {
      formData.append("File", f);
    });
  }
  if (images) {
    images.forEach((i) => {
      formData.append("Image", i);
    });
  }

  return await this._put(`/community/${cid}/news?st=${startDate}&et=${endDate}`, formData, options);
}

/**
 * @function ApiClient#GetNewsList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.startDate
 * @param {any} params.endDate
 * @param {any} params.status
 * @param {any} params.type
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetNewsList(
  cid,
  { sortBy = "", sortDesc = "", page = "", itemsPerPage = "", startDate = "", endDate = "", status = "", type = "", search = "" } = {},
  options = {},
) {
  const url = `/community/${cid}/news_list?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&st=${startDate}&et=${endDate}&s=${status}&t=${type}&ss=${search}`;

  return await this._get(url, options);
}

/**
 * @function ApiClient#DeleteNews
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} nID
 * @param {any} options = {}
 */
export async function DeleteNews(cid, nID, options = {}) {
  return await this._delete(`/community/${cid}/news/${nID}`, options);
}

// News Type Management APIs
/**
 * @function ApiClient#GetNewsTypeItemList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetNewsTypeItemList(cid, options = {}) {
  return await this._get(`/community/${cid}/news_type_list`, options);
}

/**
 * @function ApiClient#AddNewsTypeItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemName
 * @param {any} options = {}
 */
export async function AddNewsTypeItem(cid, itemName, options = {}) {
  return await this._post(`/community/${cid}/news_type?t=${itemName}`, null, options);
}

/**
 * @function ApiClient#UpdateNewsTypeItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} items
 * @param {any} options = {}
 */
export async function UpdateNewsTypeItem(cid, items, options = {}) {
  return await this._put(`/community/${cid}/news_type`, items, options);
}

/**
 * @function ApiClient#DeleteNewsTypeItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemName
 * @param {any} options = {}
 */
export async function DeleteNewsTypeItem(cid, itemName, options = {}) {
  return await this._delete(`/community/${cid}/news_type?t=${itemName}`, options);
}
